import axios from "axios";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListGambarSekolah from "./ListGambarSekolah";

const AddGambarSekolah = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error("Silakan pilih gambar terlebih dahulu.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsUploading(true);
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/gambarsekolah`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("Gambar berhasil diunggah!");
      setFile(null);
      setPreview(null);
    } catch (err) {
      toast.error(err.response?.data?.error || "Gagal mengunggah gambar.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <ToastContainer />
      <div className="max-w-xl mx-auto bg-white shadow-md rounded-lg p-6">
        <h2 className="text-2xl font-semibold mb-4 text-center">
          Tambah Gambar Sekolah
        </h2>

        <input
          type="file"
          accept="image/jpeg, image/png"
          onChange={handleFileChange}
          className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:border file:rounded file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
        />

        {preview && (
          <div className="mt-4">
            <p className="text-sm font-medium text-gray-600">Preview:</p>
            <img
              src={preview}
              alt="Preview"
              className="w-full max-h-64 object-contain mt-2 rounded border"
            />
          </div>
        )}

        <button
          onClick={handleUpload}
          disabled={isUploading}
          className="mt-6 w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
        >
          {isUploading ? "Mengunggah..." : "Unggah Gambar"}
        </button>
      </div>
      <div>
        <ListGambarSekolah />
      </div>
    </div>
  );
};

export default AddGambarSekolah;
